<template>
<div class="text-center margin-top-large"
    style="min-height: 400px; background: #E5E5E5"
    v-touch:swipeleft="test"
    v-touch:swiperight="test"
    v-touch:swipeup="test"
    v-touch:swipedown="test"
    v-touch:tap="test"
    v-touch:press="test"
    v-touch:pinchin="test"
    v-touch:pinchout="test"
>
    <h1 style="padding-top: 3em">{{msg}}</h1>
</div>
</template>


<script>
export default {

    data() {
        return {
            msg : "Wisch mir eine, drück mich, kneif mich ..."
        }
    },

    methods : {

        test : function(e) {
            
           this.msg = e.type;
        }
    }

}
</script>



// WEBPACK FOOTER //
// testtouch.vue?a5782d54